import Spacer from "components/global/Spacer";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import Backdrop from "components/global/Backdrop";
import { addMoreSlots, getBrands, getMembers, trackEvents } from "api";
import Button from "./Button";
import { showAlert } from "utils/utils";
import ModalWrapper from "./ModalWrapper";
import BillingCardSelect from "views/billing/BillingCardSelect";

const subtractIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 10C5 9.44772 5.44772 9 6 9L14 9C14.5523 9 15 9.44772 15 10C15 10.5523 14.5523 11 14 11L6 11C5.44772 11 5 10.5523 5 10Z"
      fill="#C6CBD9"
    />
  </svg>
);

const addIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 5C10.5523 5 11 5.44772 11 6V9L14 9C14.5523 9 15 9.44772 15 10C15 10.5523 14.5523 11 14 11H11V14C11 14.5523 10.5523 15 10 15C9.44771 15 9 14.5523 9 14V11H6C5.44772 11 5 10.5523 5 10C5 9.44771 5.44772 9 6 9L9 9V6C9 5.44772 9.44771 5 10 5Z"
      fill="#545454"
    />
  </svg>
);

const Wrapper = styled(Backdrop)`
  .card {
    width: 480px;
    padding: 48px;
    background-color: var(--white);
    border-radius: 16px;

    .failure-info {
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      color: #fd0403;
    }

    .title {
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
    }

    .description {
      font-size: 14px;
      font-style: normal;
      line-height: 18px;
      font-weight: 450;
    }

    .brandBox {
      border-radius: 8px;
      padding: 16px 12px;
      width: 100%;
      border: 1px solid var(--secondary);
      background: #ebf6ff;
      gap: 16px;
    }

    .divider {
      background-color: var(--secondary);
      width: 100%;
      height: 0.5px;
    }

    .mathBox {
      border: 1px solid #e2e2ea;
      padding: 4px;
      border-radius: 8px;

      .num {
        margin-left: 8px;
        margin-right: 8px;
        margin-top: 3px;
      }
    }

    .purchase-desc {
      .title {
        font-size: 14px;
        font-weight: 450;
        line-height: 20px;
      }
      .addon-desc {
        font-size: 12px;
        color: var(--body_text);
        line-height: 18px;
      }

      .amount {
        font-size: 14px;
        font-weight: 500;

        .times {
          color: var(--grey_8);
        }
      }
    }

    .miniBtn {
      width: 24px;
      height: 24px;
      border: 1px solid #e2e2ea;
      border-radius: 4px;
      padding: 2px;
    }
  }

  .btn {
    height: 48px;
    width: calc(50% - 12px);
    border-radius: 8px;
    padding: 0 24px;
    text-transform: capitalize;

    &.cancel {
      color: var(--body_text);
      border: 1px solid var(--grey_10);
    }

    &.actionBtn {
      color: var(--white);
      background-color: var(--secondary);
    }
  }

  @media screen and (max-width: 768px) {
    .card {
      width: calc(100% - 24px);
      padding: 24px;

      .title {
        font-size: 16px;
        line-height: 20px;
      }

      .description {
        font-size: 14px;
        line-height: 20px;
      }

      .textDescription {
        font-weight: 450;
      }

      .pricePer {
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
      }
    }

    .actionBtns {
      button {
        font-size: 14px;
        font-style: normal;
        font-weight: 450;
      }
    }
  }
`;

const PlanIncrement = ({
  open,
  close,
  current_sub,
  type,
  title,
  description,
  active_account,
}) => {
  const [showBillingCardSelect, setShowBillingCardSelect] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(10);
  const [count, setCount] = useState(1);

  const price =
    type === "brand"
      ? current_sub?.plan?.plus_brand
      : current_sub?.plan?.plus_user;

  // const calculateCount = (operator) => {
  //   if (operator === "+") {
  //     setCount((prev) => prev + 1);
  //   } else if (operator === "-" && count > 1) {
  //     setCount((prev) => prev - 1);
  //   }
  // };

  // track addon
  const trackManageAddon = async () => {
    const data = {
      event_name: "manage_add_on",
      event_properties: {
        date: new Date(),
        user_type: active_account?.industry,
        account_type: current_sub?.plan_name,
        add_on_type: type,
      },
    };
    try {
      await trackEvents(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddPaymentMethod = async () => {
    setIsLoading(true);
    try {
      const res = await addMoreSlots(type, { count: count });
      if (res.data.status === false) {
        showAlert({
          msg: res.data.message,
          type: "danger",
        });
      }

      if (res?.data?.status === true) {
        await trackManageAddon();
        const redirectUrl = res?.data?.data?.redirect?.url;
        if (redirectUrl) {
          window.location.replace(redirectUrl);
          return;
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      showAlert({
        msg: error.response?.data?.message ?? "Something went wrong.",
        type: "danger",
      });
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const res = await addMoreSlots(type, { count: count }, selectedCard?.id);
      if (res.data.status === false) {
        showAlert({
          msg: res.data.message,
          type: "danger",
        });
      }

      if (res?.data?.status === true) {
        await trackManageAddon();
        const redirectUrl = res?.data?.data?.redirect?.url;
        if (redirectUrl) {
          window.location.replace(redirectUrl);
          return;
        }

        if (type === "brand") {
          await getBrands();
        } else {
          await getMembers();
        }
        showAlert({
          msg: res.data?.data?.message,
          type: "success",
        });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      showAlert({
        msg: error.response?.data?.message ?? "Something went wrong.",
        type: "danger",
      });
    }
  };

  useEffect(() => {
    setTotalAmount(price * count);
  }, [count, price]);

  return (
    <>
      <BillingCardSelect
        selectedCard={selectedCard}
        setSelectedCard={setSelectedCard}
        handlePayment={handleSubmit}
        showModal={showBillingCardSelect}
        closeModal={() => setShowBillingCardSelect(false)}
        submitting={isLoading}
        handleAddPaymentMethod={handleAddPaymentMethod}
      />

      <Wrapper className={`flexRow alignCenter justifyEnd ${open && "show"}`}>
        <ModalWrapper>
          <div className="card flexColumn alignCenter">
            <h5 className="colorGrey1 textCenter title">{title}</h5>
            <Spacer y={0.6} />
            <p className="l2 colorBodyText textCenter description">
              {description}
            </p>
            <Spacer y={2.4} />
            {/* <div className="brandBox flexRow justifySpaceBetween">
            <div>
              <p className="textDescription colorGrey6">
                Number of {type === "brand" ? "brands" : "team members"}
              </p>
              <Spacer y={0.3} />
              <p className="body-3 pricePer">
                {current_sub?.plan.currency === "NGN" ? "₦" : "$"}
                {price} per {type === "brand" ? "brand" : "team member"}
              </p>
            </div>
            <div className="mathBox flexRow justifySpaceBetween">
              <button className="miniBtn" onClick={(e) => calculateCount("-")}>
                {subtractIcon}
              </button>
              <p className="body-3 num">{count}</p>
              <button className="miniBtn" onClick={(e) => calculateCount("+")}>
                {addIcon}
              </button>
            </div>
          </div>
          <Spacer y={2.4} /> */}
            <div className="brandBox amount flexColumn justifySpaceBetween">
              {type === "brand" ? (
                <div className="purchase-desc flexRow justifySpaceBetween">
                  <div>
                    <p className="title">Additional brand</p>
                    <p className="addon-desc">1 brand + 20 posts</p>
                  </div>
                  <p className="amount">
                    {current_sub?.plan.currency === "NGN" ? "₦" : "$"}
                    {totalAmount} <span className="times">x</span> 1
                  </p>
                </div>
              ) : (
                <div className="purchase-desc flexRow justifySpaceBetween">
                  <div>
                    <p className="title">Additional team member</p>
                    <p className="addon-desc">1 team member + 30 AI credits</p>
                  </div>
                  <p className="amount">
                    {current_sub?.plan.currency === "NGN" ? "₦" : "$"}
                    {totalAmount} <span className="times">x</span> 1
                  </p>
                </div>
              )}
              <div className="divider" />
              <div className="total-wrapper flexRow justifySpaceBetween">
                <div className="flexRow alignCenter justifyCenter">
                  <p className="l3 bold">Total</p>
                </div>
                <div className="flexRow alignCenter justifyCenter">
                  <p className="l2 num">
                    <b>
                      {current_sub?.plan.currency === "NGN" ? "₦" : "$"}
                      {totalAmount}/
                    </b>
                    month
                  </p>
                </div>
              </div>
            </div>
            <Spacer y={2.4} />
            <div className="flexRow justifySpaceBetween fullWidth actionBtns">
              <Button
                text="Cancel"
                onClick={close}
                fullWidth
                bg="#fff"
                color="var(--grey_1)"
                bd="var(--grey_10)"
                disabled={isLoading}
              />
              <Spacer x={2.4} />
              <Button
                text="Proceed to pay"
                loading={isLoading}
                onClick={() => {
                  if (current_sub?.plan?.currency === "NGN") {
                    setShowBillingCardSelect(true);
                    close();
                  } else {
                    handleSubmit();
                  }
                }}
                bg="var(--secondary)"
                fullWidth
                disabled={isLoading}
              />
            </div>
          </div>
        </ModalWrapper>
      </Wrapper>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    current_sub: state.current_sub,
    active_account: state.active_account,
  };
};

export default connect(mapStateToProps)(PlanIncrement);
